import { useRef, useState } from "react";
import HttpClient from "../../utils/HttpClient";

const RegistrationOTPVerification = ({ username, OTPVerificationStatus }) => {
    const inputsRef = useRef([]);
    const [formError, setFormError] = useState({
        otp: "",
        emailId: "",
    });
    const [errorMessage, setErrorMessage] = useState("");

    const handleOTPVerification = async () => {
        try {
            const data = { emailId: username, otp: getInputValues() };
            const response = await HttpClient.requestData("bl-verify-otp", "POST", data);
            if (response?.status) {
                OTPVerificationStatus(true);
            } else {
                setFormError((prevState) => ({
                    ...prevState,
                    otp: response?.error?.otp,
                    emailId: response?.error?.emailId,
                }));
                setErrorMessage(response?.message);
                OTPVerificationStatus(false);
            }
        } catch (error) {
            OTPVerificationStatus(false);
        }
    }

    const handleChange = (e, index) => {
        const value = e.target.value;
        if (value.length > 1) return;

        if (value && index < inputsRef.current.length - 1) {
            inputsRef.current[index + 1].focus();
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === 'Backspace' && !e.target.value && index > 0) {
            inputsRef.current[index - 1].focus();
        }
    };

    const getInputValues = () => {
        return inputsRef.current.map(input => input?.value || '').join('');
    };

    return (
        <div className="Searchloginformmainright" style={{ textAlign: 'center' }}>
            <div className="Searchloginformmainrightbg">
                <h2 className="_creattusettxpp mb-4" style={{ textAlign: 'center' }}>OTP Verification</h2>
                <p>Enter the OTP sent to {username}</p>
                {/* Username Field with Validation */}

                <div>
                    <div className="otp-container">
                        {[...Array(4)].map((_, i) => (
                            <input
                                key={i}
                                type="text"
                                maxLength={1}
                                className="otp-input"
                                ref={(el) => (inputsRef.current[i] = el)}
                                onChange={(e) => handleChange(e, i)}
                                onKeyDown={(e) => handleKeyDown(e, i)}
                            />
                        ))}
                    </div>
                </div>


                {formError?.otp && (
                    <p
                        className="error-message"
                        style={{
                            color: "red",
                            fontSize: "12px",
                        }}
                    >
                        {formError?.otp?.message}
                    </p>
                )}

                {formError?.emailId && (
                    <p
                        className="error-message"
                        style={{
                            color: "red",
                            fontSize: "12px",
                            marginTop: "10px"
                        }}
                    >
                        {formError?.emailId?.message}
                    </p>
                )}
                {errorMessage && (
                    <p
                        className="error-message"
                        style={{
                            color: "red",
                            fontSize: "12px",
                            marginTop: "10px"
                        }}
                    >
                        {errorMessage}
                    </p>
                )}
                <button className="btnnexttdivbtn mt-5" onClick={handleOTPVerification}>
                    Verify
                </button>
            </div>
        </div>
    );
}

export default RegistrationOTPVerification;